module.exports = __webpack_public_path__ + "static/media/login_background.a113bb1d.jpg";